import Hauptbodenformen from '../../assets/json/Hauptbodenformen.json';

/**
 * Hydromorphie-Klassifikation der Hauptbodenformen.
 *
 * Maßgeblich ist das SEA-D-Datenverzeichnis (SEA Teil D 02.2026,
 * "3. Datenverzeichnis für Bodenformen", S.31–39): es gliedert alle
 * Hauptbodenformen in 5 Hydromorphiegruppen. **Anhydromorph** ist ausschließlich
 * die Gruppe "1. Anhydromorphe Böden" (SEA-D-Seiten 81–249); ab S.250 folgen
 * Halb-, Grau- und Nassgleye sowie Moore (alle hydromorph). Insbesondere zählen
 * **sämtliche Staugley-Formen laut Katalog zu den hydromorphen Gruppen** (Stau-
 * wasser hin oder her).
 *
 * Diese Gruppierung ist deckungsgleich damit, dass der HBF-Klartext weder
 * "gley" noch "moor" enthält (Staugley/Gleymoor inklusive). Der früher nötige
 * Sonderfall `r GRa` (in der Quelle fälschlich "Skelett-Ranker" statt
 * "Skelett-Gleyranker", S.315 Halbgley) ist in Hauptbodenformen.json /
 * Feinbodenformen.json behoben und braucht keine Ausnahme mehr.
 */
const HAUPTBODENFORMEN = Hauptbodenformen as Record<string, string>;

/**
 * Liefert true, wenn die Hauptbodenform (HBF-Code, wie in `bodenform.bf[].hbf`
 * gespeichert) anhydromorph ist. Unbekannte/leere Codes sowie Moor- und
 * Gley-/Staugley-Formen gelten als nicht anhydromorph.
 *
 * Wird u.a. genutzt, um das `(G)`-Feld (reliktischer Grundwassereinfluss,
 * `bodenform.reliktG`) nur bei anhydromorpher Hauptbodenform aktivierbar zu
 * machen.
 */
export function isAnhydromorphHbf(hbf: string | undefined | null): boolean {
	if (!hbf) return false;
	const name = HAUPTBODENFORMEN[hbf];
	if (!name) return false;
	return !/gley|moor/i.test(name);
}
